import { useMemo } from 'react';
import type {
  BuyerReturnDetail,
  BuyerReturnPage,
  BuyerReturnSaleLine,
  MutateBuyerReturn,
  OpenBuyerReturn,
} from '@tcvs/shared';
import { useApi } from '../api';
export function useBuyerReturnsApi() {
  const api = useApi();
  return useMemo(
    () => ({
      list: (cursor?: string) =>
        api.request<BuyerReturnPage>('/marketplace', {
          method: 'POST',
          body: { operation: 'BUYER_RETURN_LIST', cursor },
        }),
      get: (returnId: string) =>
        api.request<BuyerReturnDetail>('/marketplace', {
          method: 'POST',
          body: { operation: 'BUYER_RETURN_GET', returnId },
        }),
      sale: (orderId: string) =>
        api.request<{ lines: BuyerReturnSaleLine[] }>('/marketplace', {
          method: 'POST',
          body: { operation: 'BUYER_RETURN_SALE', orderId },
        }),
      open: (input: OpenBuyerReturn) =>
        api.request<BuyerReturnDetail>('/marketplace', {
          method: 'POST',
          body: { operation: 'BUYER_RETURN_OPEN', ...input },
        }),
      mutate: (input: MutateBuyerReturn) =>
        api.request<BuyerReturnDetail>('/marketplace', {
          method: 'POST',
          body: { operation: 'BUYER_RETURN_MUTATE', ...input },
        }),
    }),
    [api],
  );
}
